export default __webpack_public_path__ + "static/media/backcard_pharmax.4be77371.png";